import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/views/layout/index.vue";

// 解决路由重复点击报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  // 首页
  {
    path: '/',
    name: 'home',
    component: () => import("../views/homeView.vue"),
  },
  // 用户中心
  {
    path: "/user",
    name: "user",
    component: () => import("../views/user/userView.vue"),
    children: [
      // 账户概况
      {
        path: "info",
        name: "info",
        component: () => import("@/views/user/infoView.vue"),
      },
      // 账户概况 - 修改
      {
        path: "infoEdit",
        name: "infoEdit",
        component: () => import("@/views/user/infoEditView.vue"),
      },
      // 账户充值
      {
        path: "recharge",
        name: "recharge",
        component: () => import("@/views/user/rechargeView.vue"),
      },
      // 交易记录
      {
        path: "log",
        name: "log",
        component: () => import("@/views/user/logView.vue"),
      },
      // 修改密码
      {
        path: "password",
        name: "password",
        component: () => import("@/views/user/passwordView.vue"),
      },
      // 角色管理
      {
        path: "table",
        name: "table",
        component: () => import("@/views/user/tableView.vue"),
      },
    ],
  },
  // Alpha-K
  {
    path: "/aiSearchK",
    name: "aiSearchK",
    component: () => import("../views/ai/aiSearchKView.vue"),
  },
  // Alpha-V
  {
    path: "/aiSearchV",
    name: "aiSearchV",
    component: () => import("../views/ai/aiSearchVView.vue"),
  },
  // Alpha-M
  {
    path: "/aiSearchM",
    name: "aiSearchM",
    component: () => import("../views/ai/aiSearchMView.vue"),
  },
  // 当前行情订阅
  {
    path: "/nowSub",
    name: "nowSub",
    component: () => import("../views/ai/nowSub.vue"),
  },
  // 历史行情订阅
  {
    path: "/oldSub",
    name: "oldSub",
    component: () => import("@/views/ai/oldSub.vue"),
  },
  // 金融
  {
    path: "/one3",
    name: "one3",
    component: () => import("../views/other/one3View.vue"),
  },
  // 资讯
  {
    path: "/one4",
    name: "one4",
    component: () => import("../views/other/one4View.vue"),
  },
  // 数据
  {
    path: "/one5",
    name: "one5",
    component: () => import("../views/other/one5View.vue"),
  },
  // 图形相似搜索
  {
    path: "/aiSearchInfo",
    name: "aiSearchInfo",
    component: () => import("../views/ai/aiSearchInfoView.vue"),
  },
  // 布局组件
  {
    path: '/',
    name: 'layout',
    component: Layout,
    children: [
      // AI 诊股
      {
        path: "aiChat",
        name: "AI",
        component: () => import("@/views/ai/chat/chat.vue"),
      },
      // 名人诊股
      {
        path: "famousChat",
        name: "famousChat",
        component: () => import("@/views/ai/chat/famousChat.vue"),
      },
      // 机构诊股
      {
        path: "institutionChat",
        name: "institutionChat",
        component: () => import("@/views/ai/chat/institutionChat.vue"),
      },
      // 股票
      {
        path: "/aiMain",
        name: "aiMain",
        component: () => import("@/views/ai/aiMainView.vue"),
      },
      {
        path: "/futures",
        name: "futures",
        component: () => import("../views/ai/aiMainView.vue"),
      },
      // 自选
      {
        path: "/selfStock",
        name: "selfStock",
        component: () => import("../views/ai/aiMainView.vue"),
      },
      // 涨停盘推荐
      {
        path: "/recommend",
        name: "recommend",
        component: () => import("../views/ai/recommend.vue"),
      },
      // 买卖点盯盘、期货拐点、期货趋势
      {
        path: '/watchStrategy',
        name: 'watchStrategy',
        component: () => import("@/views/ai/watchStrategy.vue"),
      },
      // 智能投顾
      {
        path: "/aiInvestment/view",
        name: "aiInvestmentView",
        component: () => import("@/views/ai/investment/aiInvestmentView.vue"),
      },
      // 用户收益
      {
        path: "/aiInvestment/trade",
        name: "aiInvestmentTrade",
        component: () => import("@/views/ai/investment/aiInvestmentTradeView.vue"),
      },
      // K线智能选股
      {
        path: "/aiKlineStock",
        name: "aiKlineStock",
        component: () => import("../views/ai/aiKlineStock/index.vue"),
        meta: {
          keepAlive: true
        }
      },
      // Ai搜索
      {
        path: "/aiSearch",
        name: "aiSearch",
        component: () => import("../views/ai/aiSearchView.vue"),
      },
      {
        path: "/positionSuggest",
        name: "positionSuggest",
        component: () => import("@/views/ai/positionSuggest.vue"),
      },
      // 涨停盘推荐
      {
        path: "/boardRecommend",
        name: "boardRecommend",
        component: () => import("../views/ai/boardRecommend/index.vue"),
      },
      // 电报
      {
        path: "/telegram",
        name: "telegram",
        component: () => import("../views/telegram/index.vue"),
      },
      // 打分策略
      {
        path: "/scoreStrategy",
        name: "scoreStrategy",
        component: () => import("../views/scoreStrategy/index.vue"),
      }
    ]
  }
]

const router = new VueRouter({ routes, mode: "history" });
export default router;
